import { TableBody, TableCell, TableContainer, TableHead, TableRow, styled } from "@mui/material";
import { AggregationData } from "components/Reports/util/QueryUtil";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { Body1 } from "@coherehealth/common";

type StatsTableDataKey = "currentQueueVolume" | "incomingVolume" | "productionVolume";

type StatsTableData = { [key in StatsTableDataKey]: AggregationData };

interface StatsTableProps {
  data: StatsTableData;
  skills: (string | undefined)[] | undefined;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tableRow: {
      height: 72,
      border: 0,
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
      "&:nth-of-type(even)": {
        backgroundColor: "#DEDFE1",
      },
    },
    body1: {
      width: 96,
      overflow: "hidden",
      textOverflow: "ellipsis",
      color: theme.palette.text.secondary,
      paddingBottom: 8,
    },
  })
);

export default function StatsTable({ data, skills }: StatsTableProps) {
  const classes = useStyles();
  return (
    <TableContainer>
      <TableHead>
        <TableRow>
          {skills?.map((skill) => (
            <StyledTableHeaderCell height={56} width={96} align="left" key={`${skill} - header`}>
              <Body1 className={classes.body1}>{skill}</Body1>
            </StyledTableHeaderCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow className={classes.tableRow}>
          {skills?.map((skill) => (
            <StyledTableCell width={96} align="left" key={`${skill} - currentQueueVolume`}>
              {data.currentQueueVolume?.[skill || ""]?.["count"] || 0}
            </StyledTableCell>
          ))}
        </TableRow>
        <TableRow className={classes.tableRow}>
          {skills?.map((skill) => (
            <StyledTableCell width={96} align="left" key={`${skill} - incomingVolume`}>
              {data.incomingVolume?.[skill || ""]?.["count"] || 0}
            </StyledTableCell>
          ))}
        </TableRow>
        <TableRow className={classes.tableRow}>
          {skills?.map((skill) => (
            <StyledTableCell width={96} align="left" key={`${skill} - productionVolume`}>
              {data.productionVolume?.[skill || ""]?.["count"] || 0}
            </StyledTableCell>
          ))}
        </TableRow>
      </TableBody>
    </TableContainer>
  );
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  border: 0,
}));

const StyledTableHeaderCell = styled(TableCell)(({ theme }) => ({
  border: 0,
  padding: "0px 8px",
  verticalAlign: "top",
}));
